export const T = {
  en_GB: { continue: "Continue", cancel: "Cancel" },
  nb_NO: { continue: "Fortsett", cancel: "Avbryt" },
} as const;
